import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

window.dotsMapConfig = window.dotsMapConfig || {};

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("dots-map__root")
);
